<template>
	<div class="animated fadeIn">
		<AccountDetailComponent
			v-bind:accountSelected="accountSelected"
			v-bind:loading="loading">
		</AccountDetailComponent>

		<b-row class="justify-content-center">
			<b-col md="12" lg="12">
				<b-card>
					<template v-slot:header>
						<b-row>
							<b-col md="6">
								<strong>Detalles del Comienzo de Trabajo (Proyecto)</strong>
							</b-col>
							<b-col md="6" class="d-flex justify-content-end">
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small>
									</b-spinner>
								</div>
							</b-col>
						</b-row>
					</template>
					<b-card-body>
						<b-row>
							<b-col md="4" lg="3">
								<h6><span class="text-info">Número de CDT: </span> {{workProject.Name}}</h6>
							</b-col>

							<b-col md="4" lg="3">
								<h6><span class="text-info">Fecha de Creación: </span>
									{{workProject.CreatedOn|dateFormatFull}}</h6>
							</b-col>

							<b-col md="4" lg="3">
								<h6><span class="text-info">Tipo: </span> {{workProject.Type}}</h6>
							</b-col>

							<b-col md="4" lg="3">
								<h6><span class="text-info">Estado: </span> {{workProject.State}}</h6>
							</b-col>

							<b-col md="4" lg="3">
								<h6><span class="text-info">Facturado: </span> {{workProject.Invoiced}}</h6>
							</b-col>

							<b-col md="4" lg="3">
								<h6><span class="text-info">Fecha de Inicio del Proyecto: </span>
									{{workProject.StartDate|dateFormatFull}}</h6>
							</b-col>

							<b-col md="4" lg="3">
								<h6><span class="text-info">Fecha Límite Dada por el Cliente: </span>
									{{workProject.LimitInstallDate|dateFormatFull}}</h6>
							</b-col>

							<b-col md="12" lg="12" class="mt-3 text-justify">
								<h6><span class="text-info">Descripción: </span> {{workProject.Description}}</h6>
							</b-col>
						</b-row>
						<b-row class="mt-4">
							<h5 class="text-info border-bottom w-100 border-info">Contactos del Proyecto</h5>
							<b-col md="4" lg="4">
								<h6>
									<span class="text-info">Contacto Primario: </span> {{workProject.PrimaryContact}}
								</h6>
							</b-col>
							<b-col md="4" lg="4">
								<h6><span class="text-info">Email Contacto Primario: </span>
									{{workProject.PrimaryContactEmail}}</h6>
							</b-col>
							<b-col md="4" lg="4">
								<h6><span class="text-info">Teléfono Contacto Primario: </span>
									{{workProject.PrimaryContactPhone}}</h6>
							</b-col>

							<b-col md="4" lg="4">
								<h6>
									<span class="text-info">Contacto Secundario: </span>
									{{workProject.SecondaryContact}}
								</h6>
							</b-col>
							<b-col md="4" lg="4">
								<h6><span class="text-info">Email Contacto Secundario: </span>
									{{workProject.SecondaryContactEmail}}</h6>
							</b-col>
							<b-col md="4" lg="4">
								<h6><span class="text-info">Teléfono Contacto Secundario: </span>
									{{workProject.SecondaryContactPhone}}</h6>
							</b-col>
						</b-row>
					</b-card-body>
				</b-card>
			</b-col>
		</b-row>

		<b-row class="justify-content-center">
			<b-col md="12" lg="12">
				<b-card>
					<template v-slot:header>
						<div role="tab">
							<b-link href="#" v-b-toggle.collapse-visitTickets
									class="text-primary d-flex justify-content-between text-decoration-none align-items-center">
								<strong>Avances de Proyecto</strong>
								<div v-if="visitTicketLoader" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small>
									</b-spinner>
								</div>
								<i v-if="!visitTicketLoader" class="when-closed fa fa-plus-circle"
								   aria-hidden="true"></i>
								<i v-if="!visitTicketLoader" class="when-opened fa fa-minus-circle"
								   aria-hidden="true"></i>
							</b-link>
						</div>
					</template>
					<b-collapse id="collapse-visitTickets">
						<b-card-body class="table-responsive">
							<b-table :items="visitTickets"
									 :fields="visitTicketTableFields"
									 :busy="visitTicketLoader"
									 :current-page="currentPage"
									 :per-page="perPage"
									 show-empty
									 striped
									 empty-filtered-text="No hay boletas de servicio disponibles"
									 empty-text="No hay boletas de servicio disponibles"
									 head-variant="light">
								<div slot="Activity" slot-scope="item" >
									{{item.item.Activity}}
								</div>

								<div slot="CheckInDate" slot-scope="item">
									{{item.item.CheckInDate | dateFormatFull}}
								</div>

								<div slot="CheckOutDate" slot-scope="item">
									{{item.item.CheckOutDate | dateFormatFull}}
								</div>

								<div slot="Detail" slot-scope="item">
									<router-link
										:to="{name: 'VisitTicketDetail', params: {id: item.item.Id}}">
										Ver
									</router-link>
								</div>

								<template v-slot:table-busy>
									<div class="text-center text-info my-2">
										<b-spinner class="align-middle"></b-spinner>
									</div>
								</template>
							</b-table>
							<nav class="d-flex justify-content-center" v-if="visitTickets.length > perPage">
								<b-pagination
									:total-rows="visitTickets.length"
									:per-page="perPage"
									v-model="currentPage"
									prev-text="<<"
									next-text=">>"
									hide-goto-end-buttons/>
							</nav>
						</b-card-body>
					</b-collapse>
				</b-card>
			</b-col>
		</b-row>

		<b-row class="justify-content-center">
			<b-col md="12" lg="12">
				<b-card>
					<template v-slot:header>
						<div role="tab">
							<b-link href="#" v-b-toggle.collapse-products
									class="text-primary d-flex justify-content-between text-decoration-none align-items-center">
								<strong>Equipos</strong>
								<div v-if="productsLoader" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small>
									</b-spinner>
								</div>
								<i v-if="!productsLoader" class="when-closed fa fa-plus-circle" aria-hidden="true"></i>
								<i v-if="!productsLoader" class="when-opened fa fa-minus-circle" aria-hidden="true"></i>
							</b-link>
						</div>
					</template>
					<b-collapse id="collapse-products">
						<b-card-body class="p-0 table-responsive">
							<b-table :items="products"
									 :fields="tableFields"
									 :busy="productsLoader"
									 show-empty
									 striped
									 empty-filtered-text="No hay equipos disponibles"
									 empty-text="No hay equipos disponibles"
									 head-variant="light">
								<template v-slot:table-busy>
									<div class="text-center text-info my-2">
										<b-spinner class="align-middle"></b-spinner>
									</div>
								</template>
							</b-table>
						</b-card-body>
					</b-collapse>
				</b-card>
			</b-col>
		</b-row>

		<b-row class="justify-content-center">
			<b-col md="12" lg="12">
				<b-card>
					<template v-slot:header>
						<div role="tab">
							<b-link href="#" v-b-toggle.collapse-invoices
									class="text-primary d-flex justify-content-between text-decoration-none align-items-center">
								<strong>Facturas</strong>
								<div v-if="invoicesLoader" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small>
									</b-spinner>
								</div>
								<i v-if="!invoicesLoader" class="when-closed fa fa-plus-circle" aria-hidden="true"></i>
								<i v-if="!invoicesLoader" class="when-opened fa fa-minus-circle" aria-hidden="true"></i>
							</b-link>
						</div>
					</template>
					<b-collapse id="collapse-invoices">
						<b-card-body class="table-responsive">
							<invoice-table-component v-bind:invoices-list="invoices" v-bind:loader="invoicesLoader"/>
						</b-card-body>
					</b-collapse>
				</b-card>
			</b-col>
		</b-row>

		<b-row class="justify-content-center">
			<b-col md="12" lg="12">
				<b-card>
					<template v-slot:header>
						<div role="tab">
							<b-link href="#" v-b-toggle.collapse-notes
									class="text-primary d-flex justify-content-between text-decoration-none align-items-center">
								<strong>Notas, Observaciones, Detalles.</strong>
								<div v-if="notesLoader" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small>
									</b-spinner>
								</div>
								<i v-if="!notesLoader" class="when-closed fa fa-plus-circle" aria-hidden="true"></i>
								<i v-if="!notesLoader" class="when-opened fa fa-minus-circle" aria-hidden="true"></i>
							</b-link>
						</div>
					</template>
					<b-collapse id="collapse-notes">
						<b-card-body class="table-responsive">
							<b-table :items="notes"
									 :fields="noteTableFields"
									 :busy="notesLoader"
									 show-empty
									 striped
									 empty-filtered-text="No hay notas disponibles"
									 empty-text="No hay notas disponibles"
									 head-variant="light">
								<div slot="CreatedOn" slot-scope="item">
									{{item.item.CreatedOn | dateFormatFull}}
								</div>
								<template v-slot:table-busy>
									<div class="text-center text-info my-2">
										<b-spinner class="align-middle"></b-spinner>
									</div>
								</template>
							</b-table>
						</b-card-body>
					</b-collapse>
				</b-card>
			</b-col>
		</b-row>

		<b-row class="justify-content-center">
			<b-col md="12" lg="12">
				<b-card>
					<template v-slot:header>
						<div role="tab">
							<b-link href="#" v-b-toggle.collapse-zoning
									class="text-primary d-flex justify-content-between text-decoration-none align-items-center">
								<strong>Zonificación</strong>
								<div v-if="zoningLoader" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small>
									</b-spinner>
								</div>
								<i v-if="!zoningLoader" class="when-closed fa fa-plus-circle" aria-hidden="true"></i>
								<i v-if="!zoningLoader" class="when-opened fa fa-minus-circle" aria-hidden="true"></i>
							</b-link>
						</div>
					</template>
					<b-collapse id="collapse-zoning">
						<b-card-body class="table-responsive">
							<b-table :items="zoning"
									 :fields="zoningTableFields"
									 :busy="zoningLoader"
									 show-empty
									 striped
									 empty-filtered-text="No hay zonificación disponibles"
									 empty-text="No hay zonificación disponibles"
									 head-variant="light">
								<div slot="CreatedOn" slot-scope="item">
									{{item.item.CreatedOn | dateFormatFull}}
								</div>
								<template v-slot:table-busy>
									<div class="text-center text-info my-2">
										<b-spinner class="align-middle"></b-spinner>
									</div>
								</template>
							</b-table>
						</b-card-body>
					</b-collapse>
				</b-card>
			</b-col>
		</b-row>

		<GoBackComponent/>
	</div>
</template>

<script>
	import AccountDetailComponent from '../components/AccountDetailComponent';
	import GoBackComponent from "../components/GoBackComponent";
	import {mapState, mapActions} from "vuex";
	import InvoiceTableComponent from "../components/InvoiceTableComponent";

	export default {
		name: "WorkProjectDetail",
		components: {
			InvoiceTableComponent,
			AccountDetailComponent,
			GoBackComponent,
		},
		data: function () {
			return {
				loading: false,
				productsLoader: false,
				notesLoader: false,
				invoicesLoader: false,
				zoningLoader: false,
				visitTicketLoader: false,
				workProject: '',
				currentPage: 1,
				perPage: 10,
				tableFields: {
					Article: {
						label: 'Artículo'
					},
					Product: {
						label: "Equipo"
					},
					Qty: {
						label: 'Cantidad'
					}
				},
				noteTableFields: {
					Name: {
						label: 'Codigo'
					},
					CreatedOn: {
						label: "Fecha de Creación"
					},
					Observations: {
						label: 'Observaciones'
					}
				},
				zoningTableFields: {
					Zone: {
						label: 'Zona'
					},
					Product: {
						label: "Producto"
					},
					Location: {
						label: 'Ubicación'
					}
				},
				visitTicketTableFields: {
					Name: {
						label: '#Boleta'
					},
					CheckInDate: {
						label: "F.Entrada"
					},
					CheckOutDate: {
						label: 'F.Salida'
					},
					Activity: {
						label: 'Trabajos Realizados'
					},
					Detail: {
						label: 'Detalles'
					}
				},
				products: [],
				notes: [],
				invoices: [],
				zoning: [],
				visitTickets: []
			}
		},
		mounted() {
			if (this.accountSelected !== '') {
				this.loading = true;
				this.productsLoader = true;
				this.notesLoader = true;
				this.invoicesLoader = true;
				this.zoningLoader = true;
				this.visitTicketLoader = true;

				const workProjectId = this.$route.params.id;

				this.getWorkProjectDetail(workProjectId)
					.then((workProject) => {
						this.workProject = workProject;
						this.getWorkProjectProducts(workProjectId)
							.then((products) => {
								this.products = products;
							})
							.catch((err) => {
								this.productsLoader = false;
								console.log(err);
							})
							.finally(() => {
								this.productsLoader = false;
							})

						this.getWorkProjectNotes(workProjectId)
							.then((notes) => {
								this.notes = notes;
							})
							.catch((err) => {
								this.notesLoader = false;
								console.log(err);
							})
							.finally(() => {
								this.notesLoader = false;
							})

						this.getWorkProjectInvoices(workProjectId)
							.then((invoices) => {
								this.invoices = invoices;
							})
							.catch((err) => {
								this.invoicesLoader = false;
								console.log(err);
							})
							.finally(() => {
								this.invoicesLoader = false;
							})

						this.getWorkProjectZoning(workProjectId)
							.then((zoning) => {
								this.zoning = zoning;
							})
							.catch((err) => {
								this.zoningLoader = false;
								console.log(err);
							})
							.finally(() => {
								this.zoningLoader = false;
							})

						this.getWorkProjectVisitTickets(workProjectId)
							.then((visitTickets) => {
								this.visitTickets = visitTickets;
							})
							.catch((err) => {
								this.visitTicketLoader = false;
								console.log(err);
							})
							.finally(() => {
								this.visitTicketLoader = false;
							})
					})
					.catch((err) => {
						console.log(err);
						this.loading = false;
					})
					.finally(() => {
						this.loading = false;
					})
			} else {
				this.$router.push('/accounts/');
			}
		},
		methods: {
			...mapActions([
				'getWorkProjectDetail',
				'getWorkProjectProducts',
				'getWorkProjectNotes',
				'getWorkProjectInvoices',
				'getWorkProjectZoning',
				'getWorkProjectVisitTickets'
			])
		},
		computed: {
			...mapState({
				accountSelected: state => state.accountSelected,
			})
		}
	}
</script>

<style scoped>
</style>
